import { useLocation } from 'react-router-dom';
import { formatPrice } from '@/shared/utils/priceFormatter';
import { readPaymentContextSession } from '../utils/paymentContextSession';

export function usePaymentContextFailureResult() {
  const location = useLocation();
  const session = readPaymentContextSession();
  const state = (location.state || {}) as { amount?: unknown };

  const amount = Number(state.amount || session?.amount || 0);

  const paymentFailedText =
    amount > 0
      ? `Your payment of ${formatPrice(amount)} failed!`
      : 'Your payment failed!';

  const refundMessage =
    'If money got deducted from account, refund will be initiated within 2 hours.';

  return {
    paymentFailedText,
    refundMessage,
  };
}